import { multiStyleConfig } from "@chakra-ui/theme-tools";
var accordion = multiStyleConfig({
  parts: {
    container: "the container for an accordion item",
    button: "the trigger for an accordion item",
    panel: "the panel for an accordion item"
  },
  baseStyle: {
    container: {
      margin: "2",
      borderRadius: "md",
      background: "white",
      shadow: "md",
      borderColor: "inherit",
      _last: {
        borderBottomWidth: "1px"
      }
    },
    button: {
      borderRadius: "md",
      color: "gray.800",
      background: "white",
      padding: "4",
      fontSize: "1rem",
      fontWeight: "bold",
      _focus: {
        boxShadow: "outline"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      },
      _expanded: {
        borderBottomWidth: "1px",
        borderTopRadius: "md",
        borderBottomRadius: "none"
      }
    },
    panel: {
      padding: "5"
    }
  },
  variants: {
    outline: function outline(props) {
      return {
        container: {
          shadow: "none",
          borderWidth: "1px",
          borderColor: "gray.300"
        }
      };
    }
  }
});
export default accordion;